import * as Sentry from "@sentry/react";

const STORAGE_KEY_PREFIX = "happydoc_quick_start_minimized_";

export function readQuickStartMinimized(userId: string, defaultValue: boolean = false): boolean {
    try {
        const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
        if (raw === null) return defaultValue;
        return raw === "true";
    } catch (error) {
        Sentry.captureException(error, { extra: { context: "quick-start-minimized-read", userId } });
        return defaultValue;
    }
}

export function writeQuickStartMinimized(userId: string, minimized: boolean): void {
    try {
        localStorage.setItem(`${STORAGE_KEY_PREFIX}${userId}`, String(minimized));
    } catch (error) {
        Sentry.captureException(error, { extra: { context: "quick-start-minimized-write", userId } });
    }
}
